// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1TIlS","boxTitle":"Qualiphy_boxTitle__LJSeN","box":"Qualiphy_box__1XLWN","toggleWrap":"Qualiphy_toggleWrap__3qZc8"};